/*
 * @Author: 傅丽宇
 * @Date: 2019-12-06 09:59:19
 * @LastEditTime: 2020-11-12 17:55:46
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \orange_big_data\src\main.js
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import echarts from 'echarts';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/style.css';
Vue.use(ElementUI);
Vue.config.productionTip = false;
//引入组件库
import jvuewheel from '@jyeontu/jvuewheel'
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)

//引入样式
import '@jyeontu/jvuewheel/lib/jvuewhell.css'
Vue.use(jvuewheel);
// 全局使用echarts
Vue.prototype.$echarts = echarts;
// vuex
import store from './store/store.js';
Vue.prototype.$store = store;

// 全局引入js方法
import Util from './utils/util.js';
Vue.prototype.$util = Util;
import tools from "../static/js/tools";
Vue.prototype.$tools = tools;
/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	components: { App },
	template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js